<template>
  <div class="bg bg--highlight" id="collection">
    <div class="bg--overlay bg--overlay__hg"></div>
    <section id="highlight" class="sections">
      <v-container>
        <v-row class="mb-10">
          <v-col cols="12" sm="4">
            <div class="sections-box">
              <div class="sections--border">
                <span class="sections--title">Koleksi</span>
                <h2 class="sections--menu">Sorotan</h2>
              </div>
            </div>
          </v-col>
          <v-col>
           Lihat lebih dekat koleksi songket dari beragam wilayah di Indonesia yang menyajikan cerita dan kekhasannya masing-masing.
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" sm="4" v-for="(high, i) in data" :key="i">
            <v-hover>
              <template v-slot:default="{ hover }">
                <v-card flat class="sections--img" :to="`detail/${i}`">
                  <div class="sections--img__zindex">
                    <div class="d-flex">
                      <img
                        class="sections--img__resp"
                        alt="gambar"
                        :src="high.img"
                      />
                    </div>
                  </div>
                  <v-fade-transition>
                    <v-overlay
                      class="highlights--hover"
                      v-if="hover"
                      absolute
                      color="white"
                      opacity="0.6"
                    >
                      <v-card-text class="black--text">
                        <v-btn x-large icon class="black--text">
                          <v-icon>mdi-open-in-new</v-icon>
                        </v-btn>
                        <div class="highlights--hover__title">
                          <p class="mb-0 text-body-1">{{high.name}}</p>
                          {{high.shortDescription}}
                        </div>
                      </v-card-text>
                    </v-overlay>
                  </v-fade-transition>
                </v-card>
              </template>
            </v-hover>
          </v-col>
        </v-row>
        <v-row class="text-center">
          <v-col>
            <v-btn text class="highlights--button my-2">
              <span>Load more</span>
            </v-btn>
          </v-col>
        </v-row>
      </v-container>
    </section>
  </div>
</template>

<script>
export default {
  name: "Highlight",
  data() {
    return {
      data: [
        {
          code: "baju",
          name: "BAJU LAMPUNG",
          shortDescription: "Berasal dari wilayah Margalima, Krui, yang terletak di pesisir Lampung",
          img: require(`@/assets/img/highlight/1.png`),
        },
        {
          code: "kalambi",
          name: "KALAMBI",
          shortDescription: "Kalambi tanpa lengan biasa dipakai oleh kalangan kelas sosial atas suku Dayak Undup",
          img: require(`@/assets/img/highlight/2.png`),
        },
        {
          code: "kampuh",
          name: "KAMPUH",
          shortDescription: "Songket kampuh termasuk ke dalam wastra agung yang hanya dipakai oleh raja, keluarga, dan bangsawan dalam lingkup kerajaan",
          img: require(`@/assets/img/highlight/3.png`),
        },
        {
          code: "ija",
          name: "IJA DUA BLAH HAH",
          shortDescription: "Nama unik kain ija dua blah hah memiliki arti kain dua belas jengkal – setara dengan dua belas hasta atau lebih dari lima meter",
          img: require(`@/assets/img/highlight/4.png`),
        },
        {
          code: "pahudu",
          name: "LAU PAHIKUNG/PAHUDU",
          shortDescription: "Masyarakat Sumba Timur mengenal teknik menenun benang tambahan, khususnya lungsi, yang dalam bahasa lokal mereka disebut pahikung atau pahudu",
          img: require(`@/assets/img/highlight/5.png`),
        },
        {
          code: "sarung",
          name: "SARUNG",
          shortDescription: "Di Sumbawa, sarung seperti ini disebut Kre Alang",
          img: require(`@/assets/img/highlight/6.png`),
        }
      ]
    };
  }
};
</script>

<style lang="scss" scoped></style>
